import useNavigateToPage from '@/hooks/useNavigateToPage';
import Card from '@/ui/components/Card';
import Heading from '@/ui/components/Heading';
import formatPersonName from '@/utils/formatPersonName';

import { Props } from './types';

const PersonRow = ({ person, isSelected, onToggleSelect }: Props) => {
  const { navigateToProfileWithId } = useNavigateToPage();

  const { first_name, last_name, profile_image_url } = person;

  const goToProfile = () => navigateToProfileWithId(person.id);

  const handleLabelClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handleCheckboxChange = () => {
    onToggleSelect?.(person.id);
  };

  return (
    <article
      aria-label={`Go to ${formatPersonName({ person })} profile`}
      className="mp-sensitive cursor-pointer px-1"
      role="link"
      onClick={goToProfile}
      onKeyDown={goToProfile}
      tabIndex={0}>
      <Card className={`hover:bg-gray-200${isSelected ? ' bg-blue-50' : ''}`}>
        <div className="flex flex-row items-center gap-3">
          {onToggleSelect && (
            <label
              aria-label={`Select ${formatPersonName({ person })}`}
              className="flex cursor-pointer items-center p-2 -m-2"
              onClick={handleLabelClick}>
              <input
                type="checkbox"
                checked={isSelected ?? false}
                onChange={handleCheckboxChange}
                className="h-4 w-4 shrink-0 cursor-pointer rounded border-gray-300 text-blue-600"
              />
            </label>
          )}
          <div className="flex flex-row items-center truncate">
            {profile_image_url ? (
              <img
                className="inline-block h-8 w-8 rounded-full"
                src={profile_image_url}
                alt="Profile Picture of Person"
              />
            ) : (
              <span className="shrink-0 inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-500">
                <span className="font-medium leading-none text-white">
                  {first_name?.[0]}
                  {last_name?.[0]}
                </span>
              </span>
            )}
            <div className="ml-4 truncate">
              <Heading className="truncate" value={3} text={formatPersonName({ person })} />
            </div>
          </div>
        </div>
      </Card>
    </article>
  );
};

export default PersonRow;
